import { ProductType } from '@hc-frontend/core-types';
import type React from 'react';

import { HealthcareInsuranceDisclaimerBottom } from '../../organisms/healthcare-insurance-disclaimer/healthcare-insurance-disclaimer';

export const DisclaimerBottom: Record<
  ProductType,
  React.ReactElement<React.PropsWithChildren> | undefined
> = {
  [ProductType.Enum.MEDICARE]: undefined,
  [ProductType.Enum.MEDICARE_ADVANTAGE]: undefined,
  [ProductType.Enum.HEALTH]: HealthcareInsuranceDisclaimerBottom(),
  [ProductType.Enum.LIFE_INSURANCE]: HealthcareInsuranceDisclaimerBottom(),
};
